// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aca93a33","455":"a048ec25","977":"2cfdd1b3"}[chunkId] + ".chunk.js";
};